import styled from 'styled-components';

import { colours } from 'themes/default';

export const ErrorMessage = styled.p`
  color: red;
  padding-top: 10px;
`;

export const FormWrapper = styled.div`
  max-width: 500px;
`;

export const Spacer = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
`;

export const ProviderLabel = styled.span`
  padding: 2px 4px;
  margin: 0 6px;
  border-radius: 6px;
  font-size: 12px;
  background: ${colours.Shades.TintBlue40};
`;

export const AmountLabel = styled.span`
  margin-right: 4px;
`;
